import React from 'react'

function Contact(props) {
  //const featuredImage = 'https://discover.frankariza.com/storage/app/uploads/public/c23/4f8/aee/thumb__1300_700_0_0_crop.jpg';
const featuredImage = '/static/trans.gif';

  return (
    <section className={props.transition}>

      <div style={{backgroundColor: '#12283B', backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover items-center h-[40vh]">
        <h1 style={{fontSize:'300%'}} className="text-center w-full pt-[20vh] text-8xl text-white">CONTACTO</h1>
    </div>

    <div className="container md:px-6 lg:px-12 py-12 mx-auto">

      <div>
      <p className="text-gray-800 px-8 lg:px-12 pt-4 lg:pt-36">  AF es una productora fundada por Frank Ariza, con una trayectoria de casi treinta títulos producidos hasta la fecha. Con base de producción en las Islas Canarias, la compañía ha desarrollado una marcada proyección internacional, rodando en países como España, Estados Unidos, México y República Dominicana. Apostamos por historias con vocación global y un fuerte arraigo creativo, colaborando con talentos y plataformas de todo el mundo.</p>
    </div>

        <div className="mx-6 mt-16">
          <p className="flex  w-full text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 mx-2 magenta dark:magenta" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>

              <span className="mx-2">
                  Calle Alcalá, N. 126<br/>28009 Madrid<br/>España
              </span>
          </p>

            <p className="flex w-full pt-6 text-gray-900">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 mx-2 magenta dark:magenta" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>

                <span className="mx-2">info@frankariza.com</span>
            </p>

        </div>
      </div>





</section>
  )
}

export default Contact
